import { render, staticRenderFns } from "./NavbarNew.vue?vue&type=template&id=2a93cc6d"
import script from "./NavbarNew.vue?vue&type=script&lang=js"
export * from "./NavbarNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports